import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CognitoRoleGuardService } from '../../../../services/router-guards/cognito-role-guard.service';
import { PermissionCognitoGroups } from '@services/token';
import { UsersComponent } from './users.component';

const routes: Routes = [
	{
		path: '',
		component: UsersComponent,
		pathMatch: 'full',
		canActivate: [CognitoRoleGuardService],
        data: {
            cognitoRoles: [PermissionCognitoGroups.userAdmin, PermissionCognitoGroups.systemAdmin]
        }
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class UsersRoutingModule {}
